export const SUPPORTED_LANGUAGES = ['ro', 'en'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export type LocalizedPage = 'home' | 'about' | 'contact' | 'surroundings';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'ro';
